export default {
  demande: {
    list: {
      headers: {
        demandeType: 'Type de demande',
        typeEntite: 'Type d\'objet',
        demandeObjet: 'Type d\'objet',
        concerne: 'Concerne',
        status: 'Statut de la demande',
        commentaire: 'Commentaire',
        dateCreation: 'Date de la demande',
        dateModification: 'Date de modification',
        demandeurCreation: 'Demandeur',
      },
    },
    status: {
      valide: 'La demande a été validée',
      refuse: 'La demande a été refusée',
      commentaire: 'Une demande complémentaire a été envoyée',
      PMFirst:
        'Veuillez traiter la demande de création de Personne morale liée',
    },
  },
};
